import clsx from "clsx";
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";

import { Breadcrumb } from "@transfr-inc/dashboard-components";
import { PageHeader } from "@transfr-inc/dashboard-components/layouts";

import { BackBreadcrumb } from "@components/common/routing/breadcrumb-back";
import { createOrganizationsLink } from "@lib/utils/navigation.utils";
import { OrganizationType } from "@models/organization";

import "./dashboard.header.scss";

export function DashboardHeader({
  title,
  subtitle,
  toolbar,
  breadcrumbLabel,
  className,
  children,
  organizationType,
}) {
  const history = useHistory();
  const isNewWindow = history.length === 1;

  const breadcrumb = useMemo(() => {
    if (breadcrumbLabel) {
      if (isNewWindow && organizationType === OrganizationType.CHILD) {
        return (
          <Breadcrumb
            label="All Organizations"
            onClick={() => history.push(createOrganizationsLink())}
          />
        );
      } else {
        return <BackBreadcrumb label={breadcrumbLabel} />;
      }
    }
    return null;
  }, [isNewWindow, organizationType, breadcrumbLabel, history]);

  return (
    <div className={clsx("dashboard-header", className, "ce")}>
      <PageHeader title={title} subTitle={subtitle} breadcrumb={breadcrumb}>
        {children}
        {toolbar}
      </PageHeader>
    </div>
  );
}
